module.exports = __webpack_public_path__ + "static/media/sap_business_one_logo.97fc364d.jpg";